<e-dropdown
  [(isActive)]="isDropdownActive"
  class="language-selection"
>
  <div
    (click)="onToggleDropdown()"
    class="language-selection__trigger"
    data-cy="language-selection.trigger"
  >
    <div class="language-selection__trigger-element">A</div>
    <div class="language-selection__trigger-element">文</div>
  </div>
  <e-dropdown-content
    [isActive]="isDropdownActive"
    data-cy="language-selection.dropdown-content">
    @for (item of languages; track item) {
      <e-dropdown-item
        (click)="onCodeClick(item.code)"
        [ngClass]="{'language-selection__dropdown-item--selected': item.code === selectedLanguage}"
        class="language-selection__dropdown-item"
        data-cy="language-selection.language-item"
      >
        <span>{{ item.value }}</span>
      </e-dropdown-item>
    }
  </e-dropdown-content>
</e-dropdown>
